import React, { Component, type ReactElement } from 'react';
import { Flex } from '@atlaskit/primitives';
import type { AnalyticsEvent } from '@atlassian/jira-common-analytics-v2-wrapped-components/src/types.tsx';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import type { Intl } from '@atlassian/jira-shared-types/src/general.tsx';
import type { Project, Group, Owner, Filter as FiltersType } from '../../../model/index.tsx';
import messages from './messages.tsx';

type OnSearchChange = (arg1: string, arg2: AnalyticsEvent) => void;
type OnOwnerChange = (owner: Owner, event: AnalyticsEvent) => void;
type OnProjectChange = (project: Project, event: AnalyticsEvent) => void;
type OnGroupChange = (group: Group, event: AnalyticsEvent) => void;
type OnClear = (event: AnalyticsEvent) => void;

export type Props = {
	renderFilterSearch: (arg1: { onChange: OnSearchChange }) => ReactElement;
	renderOwnerPicker: (arg1: { onChange: OnOwnerChange; placeholder: string }) => ReactElement;
	renderProjectPicker: (arg1: { onChange: OnProjectChange }) => ReactElement;
	renderGroupPicker: (arg1: { onChange: OnGroupChange }) => ReactElement;
	renderClear: (arg1: { onClick: OnClear }) => ReactElement;
	initialFilter: FiltersType;
	value: FiltersType;
} & Intl & {
		onChange: (filters: FiltersType, event: AnalyticsEvent) => void;
	};

// eslint-disable-next-line jira/react/no-class-components
export class Filter extends Component<Props> {
	// @ts-expect-error - TS2322 - Type 'undefined' is not assignable to type 'string'.
	onSearchChange: OnSearchChange = (query = undefined, analyticsEvent) => {
		this.props.onChange({ ...this.props.value, query }, analyticsEvent);
	};

	onOwnerChange: OnOwnerChange = (owner, analyticsEvent) => {
		this.props.onChange({ ...this.props.value, owner }, analyticsEvent);
	};

	onProjectChange: OnProjectChange = (project, analyticsEvent) => {
		this.props.onChange({ ...this.props.value, project }, analyticsEvent);
	};

	onGroupChange: OnGroupChange = (group, analyticsEvent) => {
		this.props.onChange({ ...this.props.value, group }, analyticsEvent);
	};

	onClear: OnClear = (analyticsEvent) => {
		this.props.onChange({ ...this.props.initialFilter }, analyticsEvent);
	};

	render() {
		const {
			renderFilterSearch,
			renderOwnerPicker,
			renderProjectPicker,
			renderGroupPicker,
			renderClear,
			intl: { formatMessage },
		} = this.props;

		return (
			<Flex alignItems="center" gap="space.200">
				{renderFilterSearch({
					onChange: this.onSearchChange,
				})}
				{renderOwnerPicker({
					onChange: this.onOwnerChange,
					placeholder: formatMessage(messages.ownerPlaceholder),
				})}
				{renderProjectPicker({ onChange: this.onProjectChange })}
				{renderGroupPicker({ onChange: this.onGroupChange })}
				{renderClear({ onClick: this.onClear })}
			</Flex>
		);
	}
}

export default injectIntl(Filter);
